import axios from 'axios';
import { api } from './http';

export async function uploadImage(fileOrBlob: Blob, name: string): Promise<string> {
	const fd = new FormData();
	fd.append('file', fileOrBlob, name);

	try {
		const res = await api.post('/upload-icon', fd, {
			headers: { 'Content-Type': 'multipart/form-data' },
		});

		const url = res.data?.url;
		if (typeof url === 'string' && url.trim()) {
			return url.trim();
		}

		throw new Error('Сервер не вернул ссылку на иконку');
	} catch (error) {
		if (axios.isAxiosError(error)) {
			const message = error.response?.data?.message ?? error.message;
			throw new Error(message || 'Не удалось загрузить иконку');
		}

		if (error instanceof Error) {
			throw error;
		}

		throw new Error('Не удалось загрузить иконку');
	}
}
